// extracted by mini-css-extract-plugin
module.exports = {"avatar":"AvatarHolder_avatar___mw9M","avatarCanvas":"AvatarHolder_avatarCanvas__266dg"};